import {LocationSunTime} from '@/common/interfaces/location';

export function checkIsNightHour(sunTime: LocationSunTime, hour: number) {
	if (sunTime.isPolarDay) {
		return true;
	}

	if (sunTime.isPolarNight) {
		return true;
	}

	if (!sunTime.sunrise || !sunTime.sunset) {
		return false;
	}

	const totalMinutes = hour * 60;
	return totalMinutes < sunTime.sunrise || totalMinutes > sunTime.sunset;
}
